import { useNavigate } from 'react-router';
import { useEffect } from 'react';
import axios from 'axios';
import { notification } from 'antd';
import { Fragment, useState } from 'react';
import Article from '../../assets/icons/Article';
import Button from '../../components/Button/Button';

import LiveClassCard from '../../components/LiveClass/LiveClassCard';
import TutorDashboardLayout from '../../components/TutorDashboardLayout/TutorDashboardLayout';
import Modal from 'antd/lib/modal/Modal';
import moment from 'moment';
import Spinner from '../../components/Spinner/Spinner';
import Pagination from '../../components/Pagination/Pagination';
import { baseURL } from '../../utils/axios';

const LiveClasses = () => {
  const navigate = useNavigate();

  const [scheduleModal, setScheduleModal] = useState(false);
  const [viewDetailsModal, setViewDetailsModal] = useState(false);

  const [currentMonth, setCurrentMonth] = useState('');
  const [currentYear, setCurrentYear] = useState('');
  const [start, setStart] = useState('');
  const [end, setEnd] = useState('');
  const [loading, setLoading] = useState(true);
  const [liveClasses, setLiveClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState([]);
  const [formattedDay, setFormattedDay] = useState('');
  const [itemPerView] = useState(3);
  const [currentPage, setCurrentPage] = useState(1);

  const lastItemIndex = currentPage * itemPerView;
  const firstItemIndex = lastItemIndex - itemPerView;
  const currentItems = liveClasses.slice(firstItemIndex, lastItemIndex);
  let totalNoOfPages = Math.ceil(liveClasses.length / itemPerView);

  // change page function
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  useEffect(() => {
    const currentDate = new Date();
    const month = currentDate.toLocaleString('default', { month: 'long' });
    const year = currentDate.getFullYear();
    setCurrentMonth(month);
    setCurrentYear(year);
  }, []);

  const closeModal = () => {
    setScheduleModal(false);
    setViewDetailsModal(false);
  };

  let token = localStorage.getItem('token');
  let userData = JSON.parse(localStorage.getItem('userData'));

  //axios headers
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json; charset=utf-8',
    },
  };

  const getToday = () => {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();

    today = mm + '/' + dd + '/' + yyyy;

    setStart(today);
  };

  const getEndDate = () => {
    let nextyear = new Date(
      new Date().setFullYear(new Date().getFullYear() + 1)
    );

    var dd = String(nextyear.getDate()).padStart(2, '0');
    var mm = String(nextyear.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = nextyear.getFullYear();

    nextyear = mm + '/' + dd + '/' + yyyy;
    setEnd(nextyear);
  };

  useEffect(() => {
    getEndDate();
    getToday();
  }, []);

  useEffect(() => {
    try {
      const getLiveClasses = async () => {
        setLoading(true);
        let res = await axios.get(
          `${baseURL}/teachers/${userData.id}/live-classes`,
          config
        );

        setLiveClasses(res.data.data.liveClasses);
        setLoading(false);
      };

      getLiveClasses();
    } catch (error) {
      console.log(error);
      setLoading(false);
    }

    setFormattedDay(moment().format('llll'));
  }, []);

  return (
    <TutorDashboardLayout>
      {loading ? (
        <Spinner />
      ) : liveClasses.length > 0 ? (
        <div className='tutor-liveclasses'>
          <div className='add-course__breadcrumbs'>
            <svg
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M21 11H6.83L10.41 7.41L9 6L3 12L9 18L10.41 16.59L6.83 13H21V11Z'
                fill='#161410'
              />
            </svg>
            <p>
              {' '}
              <span
                style={{ cursor: 'pointer' }}
                onClick={() => navigate('/tutor-dashboard')}
              >
                Home
              </span>{' '}
              <b style={{ color: '#161410' }}> | Live class schedule</b>
            </p>
          </div>
          <div className='tutor-liveclasses__body'>
            <div className='tutor-liveclasses__body__heading'>
              <div className='tutor-liveclasses__body__heading__left'>
                <h3>Live class</h3>
                <p>View your upcoming live classes with students here</p>
              </div>
              <div className='tutor-liveclasses__body__heading__right'>
                <Button
                  text='Schedule Live Class'
                  className={'primary-btn'}
                  onClick={() => {
                    navigate('/tutor/live-classes/create');
                  }}
                />
              </div>
            </div>
            <div className='tutor-liveclasses__body__date'>
              <h3>{currentMonth} </h3>
              <svg
                width='8'
                height='12'
                viewBox='0 0 8 12'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M0.589844 10.59L5.16984 6L0.589844 1.41L1.99984 0L7.99984 6L1.99984 12L0.589844 10.59Z'
                  fill='#5A5955'
                />
              </svg>
              <h3>{currentYear}</h3>
              <svg
                width='8'
                height='12'
                viewBox='0 0 8 12'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M0.589844 10.59L5.16984 6L0.589844 1.41L1.99984 0L7.99984 6L1.99984 12L0.589844 10.59Z'
                  fill='#5A5955'
                />
              </svg>
              {/* <button className='tutor-liveclasses__body__date__btn'>
                Day
                <svg
                  width='8'
                  height='12'
                  viewBox='0 0 8 12'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M0.589844 10.59L5.16984 6L0.589844 1.41L1.99984 0L7.99984 6L1.99984 12L0.589844 10.59Z'
                    fill='#5A5955'
                  />
                </svg>
              </button> */}
            </div>
            {liveClasses.length > 0 ? (
              <div className='tutor-liveclasses__body__cards-wrapper'>
                <div className='tutor-liveclasses__body__cards-wrapper__date'>
                  <p>{formattedDay?.split(',')[0]}</p>
                  <p>{formattedDay?.split(',')[1].trim().split(' ')[1]}</p>
                </div>
                <div style={{ width: '100%' }}>
                  <div className='tutor-liveclasses__body__cards-wrapper__card'>
                    {currentItems.map((el) => (
                      <div
                        key={el.id}
                        onClick={() => {
                          setSelectedClass(
                            liveClasses.filter((item) => item.id === el.id)
                          );
                          setViewDetailsModal(true);
                        }}
                      >
                        <LiveClassCard
                          title={el.learning_focus}
                          person='educator'
                          subtitle={el.learning_focus}
                          when={el.schedules[0]?.day}
                          groupClass={el.group_class}
                          hostMeetingUrl={el.host_meeting_url}
                          time={`${new Date(
                            '1970-01-01T' + el.schedules[0]?.start_time + 'Z'
                          ).toLocaleTimeString('en-US', {
                            timeZone: 'UTC',
                            hour12: true,
                            hour: 'numeric',
                            minute: 'numeric',
                          })} - ${new Date(
                            '1970-01-01T' + el.schedules[0]?.end_time + 'Z'
                          ).toLocaleTimeString('en-US', {
                            timeZone: 'UTC',
                            hour12: true,
                            hour: 'numeric',
                            minute: 'numeric',
                          })}  `}
                          formattedDay={formattedDay}
                          startTime={el.schedules[0]?.start_time}
                          schedules={el.schedules}
                        />
                      </div>
                    ))}
                  </div>
                  <Pagination
                    postsPerView={itemPerView}
                    totalPosts={liveClasses?.length}
                    paginate={paginate}
                    currentPage={currentPage}
                    totalPages={totalNoOfPages}
                  />
                </div>
              </div>
            ) : (
              <div
                className='tutor-dashboard__left__second-card'
                style={{ width: '100%' }}
              >
                <Article />
                <h2 className='tutor-dashboard__left__second-card__title'>
                  No live classes
                </h2>
                <p className='tutor-dashboard__left__second-card__subtitle'>
                  You have not created any live class yet, once you create, All
                  your live classes will appear here.
                </p>
                <div className='tutor-dashboard__left__second-card__btn'>
                  <button
                    onClick={() => navigate('/tutor/live-classes/create')}
                  >
                    Create Live class
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className='empty-live-class'>
          <div className='tutor-layout-right__bottom'>
            <svg
              width='36'
              height='24'
              viewBox='0 0 36 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M24 4V20H4V4H24ZM26 0H2C0.9 0 0 0.9 0 2V22C0 23.1 0.9 24 2 24H26C27.1 24 28 23.1 28 22V15L36 23V1L28 9V2C28 0.9 27.1 0 26 0Z'
                fill='#7CD1B8'
              />
            </svg>
            <h3>No scheduled class</h3>
            <p>
              All upcoming classes will appear here. Set your lesson schedule
              and duration by first creating lessons for your students
            </p>
            <Button
              className={'primary-btn'}
              text='Create Live Class'
              onClick={() => {
                navigate('/tutor/live-classes/create');
              }}
            />
          </div>
        </div>
      )}

      <Modal
        width={700}
        visible={viewDetailsModal}
        onOk={closeModal}
        onCancel={closeModal}
        footer={null}
        maskClosable={false}
      >
        <div className='details-modal'>
          <div className='details-modal__heading__tag'>
            <p>Today</p>
          </div>
          <div className='details-modal__heading__title'>
            <h3 className='details-modal__heading__title__top'>
              {selectedClass[0]?.learning_focus}
            </h3>
            <p> {selectedClass[0]?.learning_focus}</p>
          </div>

          <div className='details-modal__row'>
            <div className='details-modal__row__icon-wrapper'>
              <svg
                width='12'
                height='14'
                viewBox='0 0 12 14'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M2.66667 6.33325H4V7.66659H2.66667V6.33325ZM12 2.99992V12.3333C12 13.0666 11.4 13.6666 10.6667 13.6666H1.33333C0.593333 13.6666 0 13.0666 0 12.3333L0.00666666 2.99992C0.00666666 2.26659 0.593333 1.66659 1.33333 1.66659H2V0.333252H3.33333V1.66659H8.66667V0.333252H10V1.66659H10.6667C11.4 1.66659 12 2.26659 12 2.99992ZM1.33333 4.33325H10.6667V2.99992H1.33333V4.33325ZM10.6667 12.3333V5.66659H1.33333V12.3333H10.6667ZM8 7.66659H9.33333V6.33325H8V7.66659ZM5.33333 7.66659H6.66667V6.33325H5.33333V7.66659Z'
                  fill='#161410'
                />
              </svg>
            </div>
            <div className='details-modal__row__topic'>
              <p className='details-modal__row__topic__title'>Type of class</p>
              <p className='details-modal__row__topic__subtitle'>
                {selectedClass[0]?.group_class
                  ? 'Group Class'
                  : 'One-on-One Class'}
              </p>
            </div>
          </div>

          <div className='details-modal__row'>
            <div className='details-modal__row__icon-wrapper'>
              <svg
                width='12'
                height='14'
                viewBox='0 0 12 14'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M2.66667 6.33325H4V7.66659H2.66667V6.33325ZM12 2.99992V12.3333C12 13.0666 11.4 13.6666 10.6667 13.6666H1.33333C0.593333 13.6666 0 13.0666 0 12.3333L0.00666666 2.99992C0.00666666 2.26659 0.593333 1.66659 1.33333 1.66659H2V0.333252H3.33333V1.66659H8.66667V0.333252H10V1.66659H10.6667C11.4 1.66659 12 2.26659 12 2.99992ZM1.33333 4.33325H10.6667V2.99992H1.33333V4.33325ZM10.6667 12.3333V5.66659H1.33333V12.3333H10.6667ZM8 7.66659H9.33333V6.33325H8V7.66659ZM5.33333 7.66659H6.66667V6.33325H5.33333V7.66659Z'
                  fill='#161410'
                />
              </svg>
            </div>
            <div className='details-modal__row__topic'>
              <p className='details-modal__row__topic__title'>
                Total Number of Students Enrolled
              </p>
              <p className='details-modal__row__topic__subtitle'>
                {selectedClass[0]?.course?.students_count}/
                {selectedClass[0]?.course?.max_students} enrolled
              </p>
            </div>
          </div>

          <div className='details-modal__row'>
            <div className='details-modal__row__icon-wrapper'>
              <svg
                width='12'
                height='14'
                viewBox='0 0 12 14'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M2.66667 6.33325H4V7.66659H2.66667V6.33325ZM12 2.99992V12.3333C12 13.0666 11.4 13.6666 10.6667 13.6666H1.33333C0.593333 13.6666 0 13.0666 0 12.3333L0.00666666 2.99992C0.00666666 2.26659 0.593333 1.66659 1.33333 1.66659H2V0.333252H3.33333V1.66659H8.66667V0.333252H10V1.66659H10.6667C11.4 1.66659 12 2.26659 12 2.99992ZM1.33333 4.33325H10.6667V2.99992H1.33333V4.33325ZM10.6667 12.3333V5.66659H1.33333V12.3333H10.6667ZM8 7.66659H9.33333V6.33325H8V7.66659ZM5.33333 7.66659H6.66667V6.33325H5.33333V7.66659Z'
                  fill='#161410'
                />
              </svg>
            </div>
            <div className='details-modal__row__topic'>
              <p className='details-modal__row__topic__title'>Start Date</p>
              <p className='details-modal__row__topic__subtitle'>
                {moment(selectedClass[0]?.start_date).format('lll')}
              </p>
            </div>
          </div>

          <div className='details-modal__row'>
            <div className='details-modal__row__icon-wrapper'>
              <svg
                width='12'
                height='14'
                viewBox='0 0 12 14'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M2.66667 6.33325H4V7.66659H2.66667V6.33325ZM12 2.99992V12.3333C12 13.0666 11.4 13.6666 10.6667 13.6666H1.33333C0.593333 13.6666 0 13.0666 0 12.3333L0.00666666 2.99992C0.00666666 2.26659 0.593333 1.66659 1.33333 1.66659H2V0.333252H3.33333V1.66659H8.66667V0.333252H10V1.66659H10.6667C11.4 1.66659 12 2.26659 12 2.99992ZM1.33333 4.33325H10.6667V2.99992H1.33333V4.33325ZM10.6667 12.3333V5.66659H1.33333V12.3333H10.6667ZM8 7.66659H9.33333V6.33325H8V7.66659ZM5.33333 7.66659H6.66667V6.33325H5.33333V7.66659Z'
                  fill='#161410'
                />
              </svg>
            </div>
            <div className='details-modal__row__topic'>
              <p className='details-modal__row__topic__title'>
                Next Live Class
              </p>
              <p className='details-modal__row__topic__subtitle'>
                {moment(selectedClass[0]?.schedules[0].next_event).format(
                  'lll'
                )}
              </p>
            </div>
          </div>
        </div>
      </Modal>
    </TutorDashboardLayout>
  );
};

export default LiveClasses;
